import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Absolute Precision",
    body: "Every rim is measured, machined and colour-matched to factory tolerance. No shortcuts, no close-enough — the finish is either perfect or it is redone.",
  },
  {
    num: "02",
    title: "Automotive Craft",
    body: "Steering wheels rewrapped by hand, vinyl welded seam-by-seam, carpet fibres rebuilt strand-by-strand. Restoration is a trade, and we treat it like one.",
  },
  {
    num: "03",
    title: "Tailored Luxury",
    body: "Two-tone diamond cuts, blackout coats, Alcantara pillars and custom stitching. Your cabin and wheels should feel like they were specced for you — because they were.",
  },
];

const ManifestoSection = () => (
  <section id="manifesto" data-testid="manifesto-section" className="relative py-20 sm:py-28 lg:py-36">
    <div className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
      >
        <div className="font-mono2 text-[11px] uppercase tracking-[0.35em] text-volt mb-4">
          03 / The Standard
        </div>
        <h2 className="font-syne font-extrabold uppercase tracking-tight text-3xl sm:text-4xl lg:text-5xl text-slate-100 leading-tight max-w-3xl">
          Three rules. <span className="text-outline">No exceptions.</span>
        </h2>
      </motion.div>

      <div className="mt-14 grid md:grid-cols-3 gap-px bg-edge border border-edge rounded-2xl overflow-hidden">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.num}
            data-testid={`manifesto-chapter-${i + 1}`}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
            className="group bg-carbon p-8 sm:p-10 hover:bg-panel transition-colors duration-500"
          >
            <div className="font-syne font-extrabold text-5xl text-outline group-hover:text-outline-volt transition-all duration-500">
              {c.num}
            </div>
            <h3 className="mt-6 font-syne font-bold uppercase tracking-wider text-lg text-slate-100 group-hover:text-volt transition-colors duration-300">
              {c.title}
            </h3>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">{c.body}</p>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default ManifestoSection;
